import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 3H9c-1.85652 0-3.63699.7375-4.94975 2.05025C2.7375 6.36301 2 8.14348 2 10h2c0-1.32608.52678-2.59785 1.46447-3.53553C6.40215 5.52678 7.67392 5 9 5h6c.9882.00021 1.9541.29321 2.7758.84201.8218.54879 1.4625 1.32877 1.8412 2.24145.3788.91268.4786 1.91714.287 2.88654-.1917.9693-.6664 1.8602-1.364 2.56l-2.53 2.52.01-1.15c-.3363.064-.6777.0974-1.02.1h-3v2h2v3.9l6-6c.965-.9845 1.6178-2.2321 1.8766-3.5861.2587-1.35414.1119-2.75449-.4221-4.02545s-1.4314-2.35594-2.5797-3.11886C17.7266 3.40668 16.3786 2.9998 15 3z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2388 13.17l-1.41001-1.41-2.48 2.48-.35.35-2.83-2.83-.71.71-.7.7 2.83 2.83-2.83 2.83 1.41 1.41 2.83-2.83 2.83 2.83 1.41001-1.41-1.86001-1.86-.96-.97 1.03-1.04 1.79001-1.79z",
    fill: "currentColor"
  }));
});